"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletPOINodeInterface = void 0;
const engine_1 = require("@railgun-community/engine");
const poi_node_request_1 = require("./poi-node-request");
const shared_models_1 = require("@railgun-community/shared-models");
const utils_1 = require("../../utils");
class WalletPOINodeInterface extends engine_1.POINodeInterface {
    constructor(poiNodeURL, engine) {
        super();
        this.poiNodeRequest = new poi_node_request_1.POINodeRequest(poiNodeURL);
        this.engine = engine;
    }
    static getPOISettings(chain) {
        const network = (0, shared_models_1.networkForChain)(chain);
        if (!network) {
            throw new Error(`No network found`);
        }
        const networkPOISettings = network.poi;
        if (!networkPOISettings) {
            throw new Error(`No POI settings found`);
        }
        return networkPOISettings;
    }
    // eslint-disable-next-line class-methods-use-this
    isActive(chain) {
        return WalletPOINodeInterface.getPOISettings(chain) != null;
    }
    async getPOIsPerList(chain, listKeys, blindedCommitmentDatas) {
        const poisPerList = await this.poiNodeRequest.getPOIsPerList(chain, listKeys, blindedCommitmentDatas);
        const poisPerListConverted = {};
        for (const blindedCommitment of Object.keys(poisPerList)) {
            poisPerListConverted[blindedCommitment] = {};
            for (const listKey of Object.keys(poisPerList[blindedCommitment])) {
                const poiStatus = poisPerList[blindedCommitment][listKey];
                poisPerListConverted[blindedCommitment][listKey] =
                    WalletPOINodeInterface.poiStatusToTXOPOIStatus(poiStatus);
            }
        }
        return poisPerListConverted;
    }
    async getPOIMerkleProofs(chain, listKey, proofInputs, railgunTransactionBlockNumber) {
        const { launchBlock } = WalletPOINodeInterface.getPOISettings(chain);
        if (railgunTransactionBlockNumber < launchBlock) {
            return proofInputs.blindedCommitmentsIn.map(engine_1.createDummyMerkleProof);
        }
        return this.poiNodeRequest.getPOIMerkleProofs(chain, listKey, proofInputs.blindedCommitmentsIn);
    }
    async generateAndSubmitPOI(chain, listKey, proofInputs, blindedCommitmentsOut, txidMerklerootIndex, railgunTransactionBlockNumber) {
        const poiMerkleProofs = await this.getPOIMerkleProofs(chain, listKey, proofInputs, railgunTransactionBlockNumber);
        const finalProofInputs = {
            ...proofInputs,
            poiMerkleroots: poiMerkleProofs.map(merkleProof => merkleProof.root),
            poiInMerkleProofIndices: poiMerkleProofs.map(merkleProof => merkleProof.indices),
            poiInMerkleProofPathElements: poiMerkleProofs.map(merkleProof => merkleProof.elements),
        };
        const progressCallback = (progress) => {
            (0, utils_1.sendMessage)(`Generating POI proof for ${listKey}... ${Math.round(progress * 100)}%`);
        };
        const { proof } = await this.engine.prover.provePOI(finalProofInputs, blindedCommitmentsOut, progressCallback);
        const transactProofData = {
            snarkProof: proof,
            poiMerkleroots: poiMerkleProofs.map(merkleProof => merkleProof.root),
            txidMerkleroot: proofInputs.anyRailgunTxidMerklerootAfterTransaction,
            txidMerklerootIndex,
            blindedCommitmentOutputs: blindedCommitmentsOut,
        };
        return this.poiNodeRequest.submitPOI(chain, listKey, transactProofData);
    }
}
exports.WalletPOINodeInterface = WalletPOINodeInterface;
WalletPOINodeInterface.poiStatusToTXOPOIStatus = (poiStatus) => {
    switch (poiStatus) {
        case shared_models_1.POIStatus.Valid:
            return engine_1.TXOPOIListStatus.Valid;
        case shared_models_1.POIStatus.ShieldPending:
            return engine_1.TXOPOIListStatus.ShieldPending;
        case shared_models_1.POIStatus.ShieldBlocked:
            return engine_1.TXOPOIListStatus.ShieldBlocked;
        case shared_models_1.POIStatus.TransactProofSubmitted:
            return engine_1.TXOPOIListStatus.TransactProofSubmitted;
        case shared_models_1.POIStatus.Missing:
            return engine_1.TXOPOIListStatus.Missing;
    }
};
